module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-indicator-low-circle.5436e07e5830da539e80c55225eb37c9.svg";